export default function(baseClass, variants = []) {
  return [baseClass, ...variants.map(v => `${baseClass}--${v}`)];
}



// WEBPACK FOOTER //
// ./src/helpers/getBemClassNames.js